import { useTranslation } from "react-i18next";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
} from "@progress/kendo-react-layout";
import { formatDate } from "@progress/kendo-intl";

function GuestEventInfoCard(props) {
  const { t } = useTranslation();
  const event = props.event || {};

  return (
    <Card style={{ flex: 1 }}>
      <CardHeader>
        <CardTitle>
          <i className="fa fa-info-circle"></i> {t("event_info")}
        </CardTitle>
      </CardHeader>
      <CardBody>
        <ul style={{ listStyle: "none", paddingLeft: 0 }}>
          <li>
            <i className="fa fa-calendar"></i> {t("event_name")} :{" "}
            <b>{event.etkinliK_ADI}</b>
          </li>
          <hr />
          <li>
            <i className="fa fa-clock"></i> {t("created_date")} :{" "}
            <b>
              {event.crE_DATE
                ? formatDate(
                    new Date(event.crE_DATE),
                    t("date_formats.shortDateTime"),
                  )
                : "-"}
            </b>
          </li>
        </ul>
      </CardBody>
    </Card>
  );
}

export { GuestEventInfoCard };
